import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';

export const BubbleLoader = () => {
  const bubbleAnimation = keyframes`
    0%, 100% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
  `;

  return (
    <Box
      sx={{
        width: 'fit-content',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          '& div': {
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            animation: `${bubbleAnimation} 1.4s infinite ease-in-out`,
          },
          '& div:nth-of-type(1)': {
            animationDelay: '-0.32s',
          },
          '& div:nth-of-type(2)': {
            animationDelay: '-0.16s',
          },
          '& div:nth-of-type(3)': {
            animationDelay: '0s',
          },
        }}
      >
        <Box />
        <Box />
        <Box />
      </Box>
    </Box>
  );
};
